/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDown: {
  name: 'arrow-down';
  data: string;
} = {
  name: 'arrow-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4a1 1 0 0 1 1 1v11.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
